var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{class:'alert alert-' + _vm.classAlert,attrs:{"role":"alert"},domProps:{"innerHTML":_vm._s(_vm.msg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }